import React from "react";

import { 
    Nodes,
    Ascon,
    Ava,
    Bleenco,
    Breezometer,
    Circularise,
    Circulartree,
    Climacell,
    Datenberg,
    Forciot,
    Foretellix,
    Hiauto,
    Hydrogenious,
    Imagine,
    Inspekto,
    Monk,
    Nexmachina,
    Noiseless,
    Oculavis,
    Ontology,
    Riddleandcode,
    Senseforce,
    Silexica,
    Spherity,
    Synthesia,
    Ubq,
    Vispa,
    Voixen,
    Wem,
    Wiferion,
    Zensors,
 } from '../defaults/assets/logos/startuplogos/index';

 const StartupIcons = {
   recM5wcPifpexm4zF: Nodes,
   recHiC6NWsvKVkoMn: Ascon,
   recAbDuudbuy4iswq: Ava,
   recQm5JOTCsV76v1s: Bleenco,
   recnejGhPg8qNzLmJ: Breezometer,
   recRlQtSJ3lB1PBD8: Circularise,
   reclYYXZ39xxxvj3u: Circulartree,
   recgwP3PgfSXrIvms: Climacell,
   recJ9ju0MvVgdeH5P: Datenberg,
   recq6Xa1FAMsnOX0t: Forciot,
   recYXVaKEJy6apVnx: Foretellix,
   reca39RaBBm6V1ZOz: Hiauto,
   reccUsiNC01SK4wSi: Hydrogenious,
   recJKOAZaGcNiG8Ar: Imagine,
   recZZkFBeSJsocff2: Inspekto,
   recfOedTmIvuZcEF1: Monk,
   recdDB5aBcB3XjSLe: Nexmachina,
   recn5jdwBXIntqlHP: Noiseless,
   recvOKmnZeOahkM0c: Oculavis,
   recjpmTP4gc0KOaCO: Ontology,
   recwDPZuioc6D5pRc: Riddleandcode,
   rec8NJfBK7AfSVmOu: Senseforce,
   recjeLQ4dn5ZUPJAc: Silexica,
   recc3hzRLjUitEHQE: Spherity,
   recPu5nF6MQkPuT18: Synthesia,
   recXDxmzm6utz9ESo: Ubq,
   reczd4f3oor9pGZup: Vispa,
   rect3yuIvv9EVpeWJ: Voixen,
   recRYc6BKIYmVVSZj: Wem,
   recT2ltYvP9IeFQGs: Wiferion,
   recqbLKUJfJrUF40G: Zensors,
 }

 const StartupLogo = ({ id }) => {
   let Icon = undefined

   if (StartupIcons[id] !== undefined) {
     Icon = StartupIcons[id]
   }
   return <>{Icon ? <Icon /> : ""}</>
 }

 export default StartupLogo;